import { produce } from 'immer';
import { StateCreator } from 'zustand';
import defaultSettings from '../../../config/defaultSettings';
import { IAppStore, IAppStoreThemeSettingsSlice } from '../typing';

export const appThemeSlice: StateCreator<
  IAppStore,
  [['zustand/persist', unknown], ['zustand/immer', never]],
  [],
  IAppStoreThemeSettingsSlice
> = (set, get) => ({
  themeSettings: {
    lightTheme: 'light-default',
    darkTheme: 'dark-default',
    colorWeak: defaultSettings.colorWeak,
    themeMode: 'light',
    colorPrimary: {
      color: defaultSettings.colorPrimary,
      isPersist: false,
      updatedAt: undefined,
    },
    updatedAt: Date.now(),
  },
  setColorWeak(colorWeak) {
    set(
      produce((state: IAppStore) => {
        state.themeSettings.colorWeak = colorWeak;
      }),
    );
  },
  setLightTheme(lightTheme) {
    const themeMode = get().themeSettings.themeMode;
    set(
      produce((state: IAppStore) => {
        state.themeSettings.lightTheme = lightTheme;
      }),
    );
    if (themeMode !== 'auto') {
      get().setThemeMode('light');
    }
  },
  setDarkTheme(darkTheme) {
    const themeMode = get().themeSettings.themeMode;
    set(
      produce((state: IAppStore) => {
        state.themeSettings.darkTheme = darkTheme;
      }),
    );
    if (themeMode !== 'auto') {
      get().setThemeMode('dark');
    }
  },
  setThemeMode(themeMode) {
    set(
      produce((state: IAppStore) => {
        state.themeSettings.themeMode = themeMode;
      }),
    );
    get().setThemeUpdateAt(Date.now());
  },
  setColorPrimary(colorPrimary) {
    const stateColorPrimary = get().themeSettings.colorPrimary;
    set(
      produce((state: IAppStore) => {
        state.themeSettings.colorPrimary = { ...stateColorPrimary, ...colorPrimary };
      }),
    );
  },
  setThemeUpdateAt(updatedAt) {
    set(
      produce((state: IAppStore) => {
        state.themeSettings.updatedAt = updatedAt;
      }),
    );
  },
});
